const timer = document.getElementById("js-splash-timer");
const splashEl = document.getElementById("js-splash");

if (timer) {
    const targetDate = new Date(timer.getAttribute("data-time"));

    const daysEl = document.getElementById("js-splash-days");
    const hoursEl = document.getElementById("js-splash-hours");
    const minutesEl = document.getElementById("js-splash-min");
    const secondsEl = document.getElementById("js-splash-sec");

    function updateCountdown() {
        if(!splashEl) return;

        const now = new Date();
        const timeRemaining = targetDate - now;

        const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
        const hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

        daysEl.textContent = days;
        hoursEl.textContent = hours;
        minutesEl.textContent = minutes.toString().padStart(2, "0");
        secondsEl.textContent = seconds.toString().padStart(2, "0");

        if (timeRemaining > 0) {
            setTimeout(updateCountdown, 1000);
        }
    }

    updateCountdown();
}

function checkSplashDisabled() {
    const doDisable = window.location.search.includes('?splash=disable');
    if(doDisable) {
        localStorage.setItem('splashDisabled', "true");
    }

    if(localStorage.getItem('splashDisabled') == "true") {
        splashEl.remove();
    }
}

if(splashEl) {
    checkSplashDisabled();
}